import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import Flex from 'components/Flex';
import Text from 'components/Text';
import Button from 'components/Button';
import VisuallyHidden from 'components/VisuallyHidden';
import RadioButtonOption from 'components/RadioButtonOption';
import InlineList from 'components/InlineList';
function NoCalendarLinkedContent() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    provider = _useState2[0],
    setProvider = _useState2[1];
  function linkMyCalendar(provider) {
    var url = "/api/me/calendar/".concat(provider, "/auth");
    window.open(url, '_blank', 'noopener');
  }
  var hintId = useUniqueId();
  return /*#__PURE__*/React.createElement(Flex, {
    gap: "m",
    align: "center",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Text, {
    align: "left"
  }, t('auto_join_settings_not_connected_text')), /*#__PURE__*/React.createElement(VisuallyHidden, {
    id: hintId
  }, t('actions_select_calendar_provider')), /*#__PURE__*/React.createElement(InlineList, {
    spacing: "m",
    "aria-labelledby": hintId
  }, /*#__PURE__*/React.createElement(RadioButtonOption, {
    bold: true,
    key: "google",
    value: "google",
    label: t('property_google_calendar'),
    checked: provider === 'google',
    onChange: function onChange() {
      return setProvider('google');
    }
  }), /*#__PURE__*/React.createElement(RadioButtonOption, {
    bold: true,
    key: "microsoft",
    value: "microsoft",
    label: t('property_microsoft_calendar'),
    checked: provider === 'microsoft',
    onChange: function onChange() {
      return setProvider('microsoft');
    }
  })), /*#__PURE__*/React.createElement(Button, {
    icon: "calendar",
    variant: "primary",
    isDisabled: !provider,
    onClick: function onClick() {
      if (!provider) return;
      linkMyCalendar(provider);
    }
  }, t('actions_connect_calendar')));
}
export default NoCalendarLinkedContent;